module.exports = __webpack_public_path__ + "static/media/scene.afdedc71.png";